import { gql } from '@apollo/client';

export const GET_FEATURED_VIDEOS = gql`
  query GetFeaturedVideos($user_id: ID!) {
    listFeaturedVideos(user_id: $user_id) {
      description
      video {
        id
        preview_url
        video_url
        description
        title
      }
      title
    }
  }
`;

export const GET_CONTINUE_WATCHING_DATA = gql`
  query GetContinueWatchingData($user_id: ID!) {
    listDashboard(user_id: $user_id) {
      pathways {
        videos_count
        pathway {
          id
          name
          description
          image_url
          duration
          count_videos
          slug
          categories {
            id
            title
            slug
            parent {
              slug
              id
            }
          }
          difficulty {
            id
            icon_url
            title
          }
        }
      }
      videos {
        time
        chapter
        last_position
        completed
        video {
          id
          title
          duration
          description
          preview_url
          video_url
          user {
            id
            name
            slug
          }
          categories {
            id
            title
            slug
            parent {
              slug
              id
            }
          }
          difficulty {
            id
            icon_url
            title
          }
        }
      }
    }
  }
`;

export const GET_FEATURED_EXPERTS = gql`
  query GetFeaturedExperts($user_id: ID!) {
    listFeaturedExperts(user_id: $user_id) {
      id
      name
      avatar
      job_title
      slug
    }
  }
`;

export const GET_RECOMMENDED_VIDEOS = gql`
  query GetRecommendedVideos($user_id: ID!) {
    listRecommendedVideos(user_id: $user_id) {
      id
      title
      duration
      description
      preview_url
      video_url
      user {
        id
        name
        slug
      }
      categories {
        id
        title
        slug
        parent {
          slug
          id
        }
      }
      difficulty {
        id
        icon_url
        title
      }
    }
  }
`;

export const GET_WATCHLIST = gql`
  query GetWatchlist($user_id: ID!) {
    GetWatchList(user_id: $user_id) {
      last_position
      chapter
      time
      completed
      progress_percentage
      video {
        id
        title
        preview_url
        duration
        video_url
      }
    }
  }
`;

export const GET_LIST_LATEST_VIDEOS = gql`
  query GetListLatestVideos($user_id: ID!) {
    listlatestVideo(user_id: $user_id) {
      chapter
      time
      last_position
      completed
      video {
        id
        title
        duration
        description
        preview_url
        video_url
        user {
          id
          name
          slug
        }
        categories {
          id
          title
          slug
          parent {
            slug
            id
          }
        }
        difficulty {
          id
          icon_url
          title
        }
      }
    }
  }
`;
